import React from 'react';
import { ActivityIcon, CheckCircleIcon, AlertTriangleIcon, XCircleIcon } from 'lucide-react';
interface IntegrationCardProps {
  title: string;
  status: 'active' | 'warning' | 'error';
  lastSync: string;
  successRate: number;
}
export const IntegrationCard = ({
  title,
  status,
  lastSync,
  successRate
}: IntegrationCardProps) => {
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'active':
        return 'text-green-500';
      case 'warning':
        return 'text-yellow-500';
      case 'error':
        return 'text-red-500';
      default:
        return 'text-gray-500';
    }
  };
  const getStatusIcon = (status: string) => {
    switch (status) {
      case 'active':
        return CheckCircleIcon;
      case 'warning':
        return AlertTriangleIcon;
      case 'error':
        return XCircleIcon;
      default:
        return ActivityIcon;
    }
  };
  const StatusIcon = getStatusIcon(status);
  return <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6" data-id="element-478">
      <div className="flex items-start justify-between" data-id="element-479">
        <h3 className="font-semibold text-gray-900" data-id="element-480">{title}</h3>
        <StatusIcon className={`h-5 w-5 ${getStatusColor(status)}`} data-id="element-481" />
      </div>
      <div className="mt-4" data-id="element-482">
        <div className="flex items-center justify-between text-sm text-gray-500 mb-2" data-id="element-483">
          <span data-id="element-484">Tasa de éxito</span>
          <span className="font-medium" data-id="element-485">{successRate}%</span>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-486">
          <div className={`h-2 rounded-full ${successRate > 95 ? 'bg-green-500' : successRate > 80 ? 'bg-yellow-500' : 'bg-red-500'}`} style={{
          width: `${successRate}%`
        }} data-id="element-487"></div>
        </div>
      </div>
      <div className="mt-4 pt-4 border-t border-gray-100" data-id="element-488">
        <div className="flex items-center justify-between text-sm" data-id="element-489">
          <span className="text-gray-500" data-id="element-490">Última sincronización</span>
          <span className="text-gray-900" data-id="element-491">{lastSync}</span>
        </div>
      </div>
    </div>;
};